module.exports = "varying vec2 vUv;\r\nuniform sampler2D ramp;\r\nvoid main() {\r\n\tfloat xd = vUv.x - 0.5;\r\n\tfloat yd = vUv.y - 0.5;\r\n\r\n\tfloat dist = sqrt(xd * xd + yd * yd);\r\n\tfloat u = min(dist * 2.0, 1.0);\r\n\tvec4 col = texture2D(ramp, vec2(0.5, u));\r\n\tgl_FragColor = col;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/shaders/floor_frag.glsl
// module id = 13
// module chunks = 0